import '../ReportGrid.scss'
import './customReports.scss'
import { ReactComponent as DeleteIcon } from '../../assets/bin.svg'
import { ReactComponent as EditIcon } from '../../assets/edit-icon.svg'
import { useDeleteReport } from '../../../../api'
import { useNavigate } from 'react-router-dom'

/** @param {import('./CustomReportListItem.types').CustomReportListItemProps} props */
export const CustomReportListItem = ({ report: { id, name }, active }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (active) return
    navigate(`/reports/report-builder/${id}`)
  }

  return (
    <li className={`report-blocks-items ${active && 'active'}`} onClick={handleClick}>
      <p>{name}</p>
      <ReportListItemActions>
        <EditReportButton reportId={id} />
        <DeleteReportButton reportId={id} />
      </ReportListItemActions>
    </li>
  )
}

/** @param {React.PropsWithChildren<{}>} props */
const ReportListItemActions = ({ children }) => <div className='report-blocks-items-buttons'>{children}</div>

/** @typedef {import('./CustomReportListItem.types').ReportListItemActionButtonProps} ReportListItemActionButtonProps */

const EditReportButton = ({ reportId, ...props }) => {
  const navigate = useNavigate()

  const handleEdit = () => {
    navigate(`/reports/report-builder/${reportId}/edit`)
  }

  return (
    <ReportListItemActionButton {...props} onClick={handleEdit}>
      <EditIcon />
    </ReportListItemActionButton>
  )
}

// /** @param {Omit<ReportListItemActionButtonProps, 'children'>} props */
const DeleteReportButton = ({ reportId, ...props }) => {
  const { trigger } = useDeleteReport()
  const navigate = useNavigate()

  const handleDelete = async () => {
    // TODO: Confirmation?
    navigate('/reports/report-builder')
    await trigger(reportId)
  }

  return (
    <ReportListItemActionButton {...props} onClick={handleDelete}>
      <DeleteIcon />
    </ReportListItemActionButton>
  )
}

/** @param {ReportListItemActionButtonProps} props */
export const ReportListItemActionButton = ({ onClick, children }) => (
  <button
    onClick={(e) => {
      e.stopPropagation()
      onClick()
    }}
    className='svg-button'
  >
    {children}
  </button>
)
